import React, { useEffect, useMemo, useRef } from 'react';
import ReactECharts from 'echarts-for-react';
import { buildAiChatEChartsOption } from './buildAiChatEChartsOption';

const AiChatEChart = ({
  rows,
  columnLabels,
  chartType = 'bar',
  height = 220,
  objectName,
  currencyCtx,
}) => {
  const chartRef = useRef(null);

  const option = useMemo(
    () => buildAiChatEChartsOption(rows, columnLabels, chartType, { objectName, currencyCtx }),
    [rows, columnLabels, chartType, objectName, currencyCtx]
  );

  useEffect(() => {
    const instance = chartRef.current?.getEchartsInstance?.();
    if (!instance) return undefined;

    const resize = () => instance.resize();
    const ro = new ResizeObserver(resize);
    const container = chartRef.current?.ele;
    if (container) ro.observe(container);
    window.addEventListener('resize', resize);
    return () => {
      ro.disconnect();
      window.removeEventListener('resize', resize);
    };
  }, [option]);

  if (!option?.series?.length) {
    return (
      <div className="ai-chatbot-chart-empty text-muted small px-2 py-3">
        Could not build a chart from this data. Try a grouped question (e.g. lead count by owner).
      </div>
    );
  }

  return (
    <ReactECharts
      ref={chartRef}
      option={option}
      notMerge
      lazyUpdate
      style={{ height, width: '100%' }}
      opts={{ renderer: 'canvas' }}
    />
  );
};

export default AiChatEChart;
